export default __webpack_public_path__ + "static/simple-pie-ddc95c1982f1d63489bd5947fa04a579.png";